module.exports = __webpack_public_path__ + "static/trusted-trader-93a5abcd2da273f09f793b8ca904cb17.jpg";